export { ITagItem } from 'design-v2/common/TagPanel';
export * from 'design-v2/common/TagPanel';

import React, { useEffect, useMemo, useState } from 'react';
import TagPanel, { ITagItem } from 'design-v2/common/TagPanel';
import { IBookingTag } from 'shared-types/index';
import AdminService from "external-services/diary-admin-service/admin.service";
import TagsSerivce, { hardCodedTags } from 'external-services/tags-service';


export default function BookingTagEditor(props: {
  handleTags?: (tags: IBookingTag[]) => void;
}) {
  const [allTags, setAllTags] = useState([]);
  const [tags, setTags] = useState<IBookingTag[]>([]);

  useEffect(() => {

    const fetchData = async () => {
      const venue = AdminService.getVenue();
      const tempTags = await TagsSerivce.getTags();

      const _tags = tempTags.filter((tag) => {
        const isDeliveryFeeTag = tag._id === hardCodedTags.DELIVERY_TAG_ID;
        return venue?.isTakeAwayMode ? isDeliveryFeeTag : !isDeliveryFeeTag;
      })
      .map((tag) => ({
        ...tag,
        dynamicIconName: tag.icon,
      }));
      return _tags;
    }

    fetchData().then((res) => {
      setAllTags(res)
    })
  }, [])

  const tagMapMemo = useMemo(() => {
    return new Map(
      allTags.map((tag) => {
        return [tag.name, tag];
      })
    );
  }, [allTags]);

  const handleTagChanged = (tags: ITagItem[]) => {
    setTags(
      tags
        .map(({ name }) => {
          return tagMapMemo.get(name);
        })
        .filter((i) => i)
    )
    !!props.handleTags && props.handleTags(
      tags
        .map(({ name }) => {
          return tagMapMemo.get(name);
        })
        .filter((i) => i)
    )
  };

  const tagsMemo: ITagItem[] = useMemo(() => {
    const selectedTags = new Set(tags.map(({ name }: IBookingTag) => name));
    return allTags.map((tag) => {
      return {
        ...tag,
        selected: selectedTags.has(tag.name),
      };
    });
  }, [tags, allTags]);



  return <TagPanel
    tags={tagsMemo}
    handleTagChanged={handleTagChanged}
    groupCondition={{
      detectTagTypeId: hardCodedTags.SHARED_TAG_TYPE,
      groupLables: {
        matched: TagsSerivce.sharedTagHeading.name,
        notMatched: TagsSerivce.diaryTagHeading.name,
      }
    }}
    containerStyle={{padding: '16px 0px', position: 'relative'}}
  />;
}
